import React, { createContext, useContext } from 'react';
import { MisdeliveryFormData } from '../models/misDelivery';

interface MisdeliveryFormContextType {
  formData: MisdeliveryFormData;
  errors: Partial<Record<keyof MisdeliveryFormData, string>>;
  touched: Partial<Record<keyof MisdeliveryFormData, boolean>>;
  onFieldChange: (field: keyof MisdeliveryFormData, value: any) => void;
  onFieldBlur: (field: keyof MisdeliveryFormData) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldTouched: (field: keyof MisdeliveryFormData, touched: boolean, shouldValidate?: boolean) => void;
  disabled: boolean;
}

const MisdeliveryFormContext = createContext<MisdeliveryFormContextType | undefined>(undefined);

export const MisdeliveryFormProvider = MisdeliveryFormContext.Provider;

export const useMisdeliveryFormContext = () => {
  const context = useContext(MisdeliveryFormContext);
  if (!context) {
    throw new Error('useMisdeliveryFormContext must be used within MisdeliveryFormProvider');
  }
  return context;
};

export default MisdeliveryFormContext;
